/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityOrder } from './InternalApiEntityOrder';
import {
    InternalApiEntityOrderFromJSON,
    InternalApiEntityOrderFromJSONTyped,
    InternalApiEntityOrderToJSON,
    InternalApiEntityOrderToJSONTyped,
} from './InternalApiEntityOrder';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * 
 * @export
 * @interface InternalApiStatusSortOrderByType
 */
export interface InternalApiStatusSortOrderByType {
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiStatusSortOrderByType
     */
    alertType: InternalApiAlertType;
    /**
     * 
     * @type {Array<InternalApiEntityOrder>}
     * @memberof InternalApiStatusSortOrderByType
     */
    internalApiEntityOrder: Array<InternalApiEntityOrder>;
}



/**
 * Check if a given object implements the InternalApiStatusSortOrderByType interface.
 */
export function instanceOfInternalApiStatusSortOrderByType(value: object): value is InternalApiStatusSortOrderByType {
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    if (!('internalApiEntityOrder' in value) || value['internalApiEntityOrder'] === undefined) return false;
    return true;
}

export function InternalApiStatusSortOrderByTypeFromJSON(json: any): InternalApiStatusSortOrderByType {
    return InternalApiStatusSortOrderByTypeFromJSONTyped(json, false);
}

export function InternalApiStatusSortOrderByTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiStatusSortOrderByType {
    if (json == null) {
        return json;
    }
    return {
        
        'alertType': InternalApiAlertTypeFromJSON(json['alertType']),
        'internalApiEntityOrder': ((json['internalApiEntityOrder'] as Array<any>).map(InternalApiEntityOrderFromJSON)),
    };
}

export function InternalApiStatusSortOrderByTypeToJSON(json: any): InternalApiStatusSortOrderByType {
    return InternalApiStatusSortOrderByTypeToJSONTyped(json, false);
}

export function InternalApiStatusSortOrderByTypeToJSONTyped(value?: InternalApiStatusSortOrderByType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
        'internalApiEntityOrder': ((value['internalApiEntityOrder'] as Array<any>).map(InternalApiEntityOrderToJSON)),
    };
}

